<template>
  <AutoCompleter :placeholder="placeholder" ref="completer" :results="results" :iid="iid" @reload="reload" @selected="selectValue">
    <template v-slot:listitem="data">
      {{ data.result.map_id }} - {{ data.result.title }}
    </template>
  </AutoCompleter>
</template>

<script>
import customers from '@/modules/customers.js'
import AutoCompleter from '@/components/AutoCompleter.vue'

export default {
  name: 'CustomerAutoCompleter',
  props: {
    iid: { type: String, required: false, default : ''},
    placeholder: { type: String, required: false, default: ''}
  },
  components: {
    AutoCompleter,
  },
  data() {
    return {
      results: [],
    }
  },
  created: function() {
    customers.viewparams.page = 1;
    console.log(this.placeholder);
  },
  methods: {
    selectValue(data) {
      var link = { title: data.map_id + ' ' + data.title };
      this.$refs.completer.updateValue(data.map_id,link);
    },
    reload(search) {
      console.log(search);
      customers.viewparams.search = search;
      var self = this;
      customers.list(function(data) {
        self.results = data.rows;
      })
    }
  }
}
</script>
